import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: false
})
export class HighlightPipe implements PipeTransform {

  transform(value: string, args: string): any {
    if (args && value) {
      const startIndex = value.toLowerCase().indexOf(args.toLowerCase());
      if (startIndex !== -1) {
        const endLength = args.length;
        const matchingString = value.substr(startIndex, endLength);
        return value.replace(matchingString, '<mark>' + matchingString + '</mark>');
      }

    }
    return value;
  }

}
